import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=0b2e7f4d&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=js"
export * from "./Legend.vue?vue&type=script&lang=js"
import style0 from "./Legend.vue?vue&type=style&index=0&id=0b2e7f4d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e7f4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2e7f4d')) {
      api.createRecord('0b2e7f4d', component.options)
    } else {
      api.reload('0b2e7f4d', component.options)
    }
    module.hot.accept("./Legend.vue?vue&type=template&id=0b2e7f4d&scoped=true", function () {
      api.rerender('0b2e7f4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ds/Legend.vue"
export default component.exports